import Layout from "../components/Layout";
import PageHeader from "../components/PageHeader";

export default function Dmca() {
  return (
    <Layout title="DMCA Policy">
      <div>
        <PageHeader label="Eventive" headline="DMCA Policy" />
        <div className="embedded-content mt-4 relative max-w-xl mx-auto px-6 sm:px-6 lg:px-8 lg:max-w-screen-lg">
          <p>Last updated: January 2, 2022</p>
          <p>
            It is our policy to expeditiously respond to notices of alleged
            copyright infringement that comply with the United States Digital
            Millennium Copyright Act (&quot;DMCA&quot;). This policy describes
            the information that should be present in these notices and the take
            down procedure we follow with respect to allegedly infringing
            material. If we receive proper notification of claimed copyright
            infringement, our response to these notices may include removing or
            disabling access to the allegedly infringing material and/or
            terminating or suspending users. If we remove or disable access in
            response to such a notice, we will make a good-faith attempt to
            contact the provider of the allegedly infringing content so that
            they may make a counter notification pursuant to the DMCA. It is our
            policy to accommodate and not interfere with standard technical
            measures used by copyright owners to identify or protect their
            copyrighted works that we determine are reasonable under the
            circumstances.
          </p>
          <p>
            If you believe that any Content on our website or services infringes
            upon any copyright which you own or control, you may send a written
            notification with an electronic or physical signature of a person
            authorized to act on behalf of the copyright owner to our designated
            copyright agent (the &ldquo;Designated Agent&rdquo;), identified
            below, with the following information:
          </p>
          <ul>
            <li>
              A description of the copyrighted work or other intellectual
              property that you claim has been infringed, with sufficient detail
              so that we can identify the alleged infringing material;
            </li>
            <li>
              The URL or other specific location on the Site that contains the
              alleged infringing material described in (a) above, with
              reasonably sufficient information to enable us to locate the
              alleged infringing material;
            </li>
            <li>
              Your name, mailing address, telephone number and email address;
            </li>
            <li>
              The electronic or physical signature of the owner of the copyright
              or a person authorized to act on the owner&rsquo;s behalf;
            </li>
            <li>
              A statement by you that you have a good faith belief that the
              disputed use is not authorized by the copyright owner, its agent,
              or the law; and
            </li>
            <li>
              A statement by you that the information contained in your notice
              is accurate and that you attest under penalty of perjury that you
              are the copyright owner or that you are authorized to act on the
              copyright owner&rsquo;s behalf.
            </li>
          </ul>
          <p>
            Attn: DMCA Notice
            <br />
            Eventive LLC
            <br />
            Address: 438 Tennessee Street, Memphis, TN 38103
            <br />
            Email: dmca@eventive.org
          </p>
          <p>
            UNDER FEDERAL LAW, IF YOU KNOWINGLY MISREPRESENT THAT ONLINE
            MATERIAL IS INFRINGING, YOU MAY BE SUBJECT TO CRIMINAL PROSECUTION
            FOR PERJURY AND CIVIL PENALTIES, INCLUDING MONETARY DAMAGES, COURT
            COSTS, AND ATTORNEYS&rsquo; FEES.
          </p>
          <p>
            Please note that this procedure is exclusively for notifying
            Eventive that your copyrighted material has been infringed. The
            preceding requirements are intended to comply with Eventive&apos;s
            rights and obligations under the DMCA, including 17 U.S.C.
            &sect;512(c), but do not constitute legal advice. It may be
            advisable to contact an attorney regarding your rights and
            obligations under the DMCA and other applicable laws.
          </p>
          <p>
            To notify the provider of the allegedly infringing material to which
            we have removed or disabled access, we may forward a copy of your
            infringement notice, including your name and email address to the
            provider of the allegedly infringing material.&nbsp;
          </p>
          <p>
            We may terminate users who, in our sole discretion, are deemed to be
            repeat infringers. Knowingly misrepresenting in a notification that
            material is infringing can subject you to damages, including costs
            and attorneys&rsquo; fees, incurred by us or the alleged infringer.
            If you receive an infringement notification from us, you may file a
            counter notification pursuant with our Designated Agent pursuant to
            the DMCA. To file a counter notification, please provide our
            Designated Agent with the following information:&nbsp;
          </p>
          <ul>
            <li>
              Identification of the material that has been removed or to which
              access has been disabled and the location at which the material
              appeared before it was removed or access was disabled;
            </li>
            <li>
              Your name, mailing address, telephone number and email address;
            </li>
            <li>
              The following statement: &quot;I consent to the jurisdiction of
              Federal District Court for the United States District Court for
              the Western District of Tennessee&quot;;
            </li>
            <li>
              The following statement: &quot;I will accept service of process
              from [insert the name of the person who submitted the infringement
              notification] or his/her agent&quot;;
            </li>
            <li>
              The following statement: &quot;I swear, under penalty of perjury,
              that I have a good faith belief that the affected material was
              removed or disabled as a result of a mistake or misidentification
              of the material to be removed or disabled&quot;; and
            </li>
            <li>Your signature, in physical or electronic form.</li>
          </ul>
          <p>
            Upon receipt of valid counter notification, we will promptly provide
            the person who provided the original infringement notification with
            a copy of your counter notification and inform that person that we
            will replace the removed material or cease disabling access to it in
            10 business days. Further, we will replace the removed material and
            cease disabling access to it not less than 10, nor more than 14,
            business days following receipt of your counter notice, unless
            Designated Agent first receives notice from the person who submitted
            the original infringement notification that such person has filed an
            action seeking a court order to restrain you from engaging in
            infringing activity relating to the material on the Site.
          </p>
        </div>
      </div>
    </Layout>
  );
}
